import { get } from 'lodash'

export function getBins (order) {
  const qty = parseFloat(order.qty) || 0
  const binMax = parseFloat(get(order, 'product.type.bin_max')) || 0
  const binUomId = parseInt(get(order, 'product.type.bin_uom_id'), 10) || false

  if (!qty) throw new Error('Unable to get order qty to bin it out.')

  if (!binMax || binMax >= qty) return false
  if (binUomId && parseInt(order.uom_id, 10) !== binUomId) return false

  let count = Math.ceil(qty / binMax)
  let remainder = qty % binMax
  let bins = Array(count).fill(binMax)
  if (remainder) bins[bins.length - 1] = remainder // if a remainder exists, set the final bin to be this

  let binnedTotal = bins.reduce((a, t) => a + t)
  if (parseFloat(binnedTotal) !== parseFloat(qty)) {
    throw new Error(`Error binning the order; ${bins.length} bins totalling ${binnedTotal} vs ${qty}.`)
  }

  return bins
}



// WEBPACK FOOTER //
// ./src/helpers/orders.js